<template>
  <div>
    <slot v-bind="{ show }"/>
    <div class="flex justify-center">
      <l-button
        class="mt-3 font-medium border-0 text-center mx-auto p-2 text-orange-600 hover:text-orange-700"
        @click="show = !show"
      >
        Show {{ show ? "less" : "more" }}
      </l-button>
    </div>
  </div>
</template>

<script setup>
import LButton from "@/components/buttons/LButton.vue"
import { ref } from "vue"

defineProps({
  as: { type: String, default: "div" },
})

const show = ref(false)
</script>
